import * as React from 'react';
import { colors } from '../styles/colors';

interface IProps {
    containerStyle?: React.CSSProperties;
    onClick(): void;
    buttonContent: React.ReactNode;
    fontStyle?: React.CSSProperties;
    isDisabled?: boolean;
}

export class CommonActionButton extends React.Component<IProps> {
    //TODO: Add hover and on-press animations to this component
    public render() {
        const isDisabledStyle = this.props.isDisabled ? { opacity: 0.3 } : {};
        const containerStyle = { ...styles.defaultContainer, ...this.props.containerStyle };

        return (
            <button style={{ ...styles.container, ...containerStyle, ...isDisabledStyle }} onClick={() => this.props.onClick()}>
                <span className="unselectable" style={{ ...styles.buttonText, ...this.props.fontStyle }}>
                    {this.props.buttonContent}
                </span>
            </button>
        );
    }
}

const styles = {
    defaultContainer: {
        width: 175,
        height: 55
    },
    container: {
        borderRadius: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: colors.ACTION_GREEN,
        cursor: 'pointer'
    } as React.CSSProperties,
    buttonText: {
        color: 'white',
        fontSize: 18,
        fontWeight: 400,
        textAlign: 'center'
    } as React.CSSProperties
};



// WEBPACK FOOTER //
// ./src/SharedComponents/CommonActionButton.tsx